import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic Validation
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setStatus({ type: "error", message: "All fields are required!" });
      return;
    }

    try {
      const response = await fetch("https://admin.leapatinternational.com/sentmail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setStatus({ type: "success", message: "Message sent successfully!" });
        setFormData({ name: "", email: "", subject: "", message: "" }); // Reset form
      } else {
        setStatus({ type: "error", message: result.message || "Something went wrong!" });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Failed to send message!" });
    }
  };

  return (
    <div className="container-xxl py-5 contact_fo">
      <div className="container">
        <div className="row g-4">
          {/* Left Side - Google Map */}
          <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="text-secondary text-uppercase get_in_touch" style={{ color : '#17224D !important' }}>Get In Touch</h6>
            <h1 className="mb-4">Contact For Any Query</h1>
            <p className="mb-4">
              Have any questions? Feel free to reach out via the form. Our team will get back to you soon.
            </p>
            {/* <iframe
              className="position-relative w-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
              frameBorder="0"
              style={{ height: "300px", border: "0" }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe> */}
            <div class="col-lg-12 col-md-12">
                  <h4 class=" mb-2">Address</h4>
                  <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i> Leapat International LLC Fort Worth-TX, USA</p>
                  <p class="mb-2"><i class="fa fa-phone-alt me-3"></i>+1-401-660-3457</p>
                  <p class="mb-2"><i class="fa fa-envelope me-3"></i>hiten@leapatllc.com</p>
              </div>
              <div class="col-lg-12 col-md-12">
                  <h4 class=" mb-2 mt-4">Opening Hours</h4>
                  <h6 class="">Monday - Friday:</h6>
                  <p class="mb-4">09.00 AM - 09.00 PM</p>
                  <h6 class="">Saturday - Sunday:</h6>
                  <p class="mb-0">09.00 AM - 12.00 PM</p>
              </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="bg-light p-5 h-100 d-flex align-items-center">
              <form onSubmit={handleSubmit}>
                {status.message && (
                  <div
                    className={`alert ${
                      status.type === "success" ? "alert-success" : "alert-danger"
                    }`}
                  >
                    {status.message}
                  </div>
                )}
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your Name"
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Your Email"
                        required
                      />
                      <label htmlFor="email">Your Email</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Subject"
                        required
                      />
                      <label htmlFor="subject">Subject</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: "150px" }}
                        required
                      ></textarea>
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary w-100 py-3 contact_btns" type="submit">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>

      <style>
        {`
          /* Add your custom CSS here */
          .get_in_touch {
           color: #17224D !important
          }
  .contact_btns{
         background-color: #17224D !important;
         border-color: #17224D !important
          }

         .contact_fo {
          margin-top: 135px;
          }
        
        `}
      </style>

    </div>
  );
};

export default Contact;
